import React from 'react';
import ReviewHistoryItem from './ReviewHistoryItem';
const ReviewHistoryList = _ref => {
  let {
    reviewHistory
  } = _ref;
  if (!reviewHistory || reviewHistory.length === 0) {
    return null;
  }
  const sortedReviews = [...reviewHistory].sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
  return /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, sortedReviews.map((review, index) => /*#__PURE__*/React.createElement(ReviewHistoryItem, {
    key: review.id,
    review: review,
    showStatus: index === sortedReviews.length - 1
  })));
};
export default ReviewHistoryList;